import Swiper from 'swiper/bundle';

export const studentWorksGallery = (): void => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (function(window, document, $) {
    const targetSelector = '.js-studentWorksGallery';
    const target = document.querySelector(targetSelector);
    const thumbClass = '.js-studentWorksGalleryThumbnails';
    const detailClass = '.js-studentWorksGalleryDetails';
    const activePageClass = '-active';
    const options = {
      effect: 'fade',
      speed: 1500
    };
    if (!target) return;
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const sliderDetail = new Swiper(detailClass, {
      effect: options.effect,
      speed: options.speed,
      slidesPerView: 1,
      grabCursor: false,
      allowTouchMove: false
    });
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const sliderThumbnail = new Swiper(thumbClass, {
      // effect: 'fade',
      loop: false,
      spaceBetween: 24,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
    });
    console.log('gallery');
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const swiper = new Swiper(targetSelector, {
      thumbs: {
        swiper: sliderThumbnail
      },
      effect: options.effect,
      loop: false,
      speed: options.speed,
      autoplay: false,
      allowTouchMove: false,
      navigation: {
        nextEl: '.js-studentWorksGalleryThumbnailsNext',
        prevEl: '.js-studentWorksGalleryThumbnailsPrev'
      },
      on: {
        slideChange(swiper) {
          console.log(sliderDetail);
          console.log('slide index', swiper.activeIndex);
          sliderDetail[0].slideTo(swiper.activeIndex);
          sliderDetail[1].slideTo(swiper.activeIndex);
        }
      }
      // autoHeight: false,
      // pagination: {
      //   el: '.js-entryPostHeadCarousel__pagination',
      //   type: 'custom',
      //   // https://takblog.site/web/?p=632
      //   renderCustom: function(swiper, current, total) {
      //     const slides = swiper.slides;
      //     console.log(slides);
      //     let html = '';
      //     for (let i = 0; i < total; i++) {
      //
      //       if (slides[i].classList.contains('swiper-slide-duplicate')) {
      //         console.log(slides[i]);
      //         continue;
      //       }
      //
      //       if (current == i + 1) {
      //         html = html + `<div class="${thumbClass} ${activePageClass}" data-slideto="${i}"><div class="a-thumbnail">${slides[i].innerHTML}</div></div>`;
      //       } else {
      //         html = html + `<div class="${thumbClass}" data-slideto="${i}"><div class="a-thumbnail">${slides[i].innerHTML}</div></div>`;
      //       }
      //     }
      //     return html;
      //   }
      // }
    });
    // const clickThumbs = () => {
    //   const thumbItems = document.getElementsByClassName(thumbClass);
    //   for (let i = 0; i < thumbItems.length; i++) {
    //     thumbItems[i].addEventListener(
    //       'click',
    //       e => {
    //         // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //         // @ts-ignore
    //         const index = e.currentTarget.dataset.slideto;
    //         swiper.slideTo(index, 1500, true);
    //         // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //         // @ts-ignore
    //         setTimeout(swiper.autoplay.start, 5000);
    //         // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    //         // @ts-ignore
    //         // e.target.classList.toggle(activePageClass);
    //       },
    //       false
    //     );
    //   }
    // };
    // clickThumbs();
    // swiper.on('slideChange', clickThumbs);

  })(window, document, jQuery);
};
